export function attachSubtree(rootNode, targetGedId, newSubtree) {
  if (!rootNode) return false

  if (rootNode.attributes?.isMarriage && rootNode.spouses) {
    const hasTarget = rootNode.spouses.some((sp) => sp.gedId === targetGedId)
    if (hasTarget) {
      rootNode.children = [...(rootNode.children || []), ...newSubtree.children]
      return true
    }
  }

  if (rootNode.attributes?.gedId === targetGedId) {
    rootNode.children = [...(rootNode.children || []), ...newSubtree.children]
    return true
  }

  if (rootNode.children) {
    for (const child of rootNode.children) {
      if (attachSubtree(child, targetGedId, newSubtree)) {
        return true
      }
    }
  }

  return false
}